import { supabase } from '@/lib/supabase'
import type { Tables } from '@/types/database.types'

export type ChecklistItem = Tables<'checklist_items'>
export type ChecklistCategory = 'luggage' | 'documents' | 'health' | 'tasks'

export interface NewChecklistItemInput {
  tripId: string
  label: string
  category?: ChecklistCategory
}

export async function listChecklistItems(tripId: string): Promise<ChecklistItem[]> {
  const { data, error } = await supabase
    .from('checklist_items')
    .select('*')
    .eq('trip_id', tripId)
    .order('created_at')
  if (error) throw error
  return data
}

export async function createChecklistItem(input: NewChecklistItemInput): Promise<ChecklistItem> {
  const { data, error } = await supabase
    .from('checklist_items')
    .insert({
      trip_id: input.tripId,
      label: input.label,
      category: input.category,
    })
    .select()
    .single()
  if (error) throw error
  return data
}

export async function setChecklistItemChecked(itemId: string, checked: boolean): Promise<void> {
  const { error } = await supabase.from('checklist_items').update({ checked }).eq('id', itemId)
  if (error) throw error
}

export async function deleteChecklistItem(itemId: string): Promise<void> {
  const { error } = await supabase.from('checklist_items').delete().eq('id', itemId)
  if (error) throw error
}
